export default [
  {
    path: "/4xWO2q8qtQpLrF2kI6SI",
    children: [
    {
        path: "",
        name: "transactionList",
        meta: {
          title: "Transactions",
          authRequired: true,
          acc: ['y50321']
        },
        component: () => import("../views/transactions/index.vue"),
      },

      
      
    ],
  },
];
